import { Routes, Route, useOutletContext } from "react-router-dom";
import ListeNotesFrais from "../Pages/Private/NotesFrais/ListeNotesFrais";
import GestionNotesFrais from "../Pages/Private/NotesFrais/GestionNotesFrais";

export const NotesRouter = () => {
    const [user, setUser] = useOutletContext();

    return (
        <Routes>
            <Route path="notes" element={<ListeNotesFrais />} />{" "}
            <Route path="gestion" element={<GestionNotesFrais />} />{" "}
        </Routes>
    );
};
